import {create} from 'zustand'
import {AuthState, AuthUser} from '@/features/auth/types.ts'
import {LOCAL_STORAGE_ACCESS_TOKEN, LOCAL_STORAGE_REFRESH_TOKEN} from '@/features/auth/constants.ts'
import {updateSocketAuth} from '@/socket'

type AuthStoreActions = {
    reset: () => void
    setAuthUser: (data: AuthUser) => void
    setAuthData: (data: {user: AuthUser; accessToken: string; refreshToken: string}) => void
}

export const useAuthStore = create<Partial<AuthState> & AuthStoreActions>()(set => ({
    user: null,
    accessToken: localStorage.getItem(LOCAL_STORAGE_ACCESS_TOKEN) || undefined,
    refreshToken: localStorage.getItem(LOCAL_STORAGE_REFRESH_TOKEN) || undefined,
    reset: () => {
        localStorage.removeItem(LOCAL_STORAGE_ACCESS_TOKEN)
        localStorage.removeItem(LOCAL_STORAGE_REFRESH_TOKEN)
        set({user: null, accessToken: undefined, refreshToken: undefined})
        updateSocketAuth()
    },
    setAuthUser: user => set({user}),
    setAuthData: data => {
        localStorage.setItem(LOCAL_STORAGE_ACCESS_TOKEN, data.accessToken)
        localStorage.setItem(LOCAL_STORAGE_REFRESH_TOKEN, data.refreshToken)
        set({user: data.user, accessToken: data.accessToken, refreshToken: data.refreshToken})
        updateSocketAuth(data.accessToken)
    }
}))

export const usePermissions = () => useAuthStore(state => state.user?.permissions)
